export default __webpack_public_path__ + "static/media/boomsell.1d99e32d.png";